/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/brush'
export default icon
